// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import TwitterOutlinedSvg from "@fishx/icons-svg/es/asn/TwitterOutlined";
import FishxIcon from '../components/FishxIcon';

var TwitterOutlined = function TwitterOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: TwitterOutlinedSvg
  }));
};

TwitterOutlined.displayName = 'TwitterOutlined';
export default React.forwardRef(TwitterOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/TwitterOutlined.js
// module id = 4293
// module chunks = 0